import { BaseCssTheme } from "@swiggy-private/dls-web-common/dist/components/themes/BaseCss/BaseCssTheme";
import { InstamartTheme } from "@swiggy-private/dls-web-common/dist/components/themes/precomputed/Instamart/InstamartTheme";
import { ToingTheme } from "@swiggy-private/dls-web-common/dist/components/themes/precomputed/Toing/ToingTheme";
import { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge/dist/interfaces";
import { isImShell, isToingApp } from "helpers";

export const getTheme = (headers: GetSwiggyHeadersResponsePayload) => {
    const channel = headers?.["x-channel"];

    if (isImShell(channel)) {
        return InstamartTheme;
    } else if (isToingApp(channel)) {
        return ToingTheme;
    } else {
        return BaseCssTheme;
    }
};
